import { FC } from "react";
import { Severity } from "../../Helpers";
import styles from "./Tag.module.scss";
import { classNames } from "../../Utilities";

interface TagProps {
    severity: Severity;
    text: string | number;
}

export const Tag: FC<TagProps> = (props) => {
    const getStyle = () => {
        switch (props.severity) {
            case Severity.Primary:
                return styles.primary;
            case Severity.Secondary:
                return styles.secondary;
            case Severity.Info:
                return styles.info;
            case Severity.Success:
                return styles.success;
            case Severity.Warning:
                return styles.warning;
            case Severity.Danger:
                return styles.danger;
            default:
                return styles.primary;
        }
    };

    return (
        <div className={classNames([styles.tag, getStyle()])}>
            {props.text}
        </div>
    );
};